import { BookIcon } from 'lucide-react';

import { Customizations } from '../types.ts';
import { ORGANIZATION_PROFILE_GENERAL_TAB_FORM_FIELD_CONFIGS } from './OrganizationProfileGeneralTabFormFieldConfigs.tsx';

export default {
    OrganizationSettingsProfileTabFormFieldConfigs: ORGANIZATION_PROFILE_GENERAL_TAB_FORM_FIELD_CONFIGS,
    OrganizationProfileGeneralTabFormFieldConfigs: ORGANIZATION_PROFILE_GENERAL_TAB_FORM_FIELD_CONFIGS,
    OrganizationListPageFilterConfigs: [
        { name: 'studyFormats', translationKey: 'customizations:deinstudiumbb.filters.studyFormat' },
        { name: 'universityTypes', translationKey: 'customizations:deinstudiumbb.filters.universityType' },
        { name: 'fieldsOfStudy', translationKey: 'customizations:deinstudiumbb.filters.fieldsOfStudy' },
        { name: 'topics', translationKey: 'customizations:deinstudiumbb.filters.topics' },
        { name: 'federalStates', translationKey: 'customizations:deinstudiumbb.filters.federalState' },
        { name: 'personalityTypes', translationKey: 'customizations:deinstudiumbb.filters.personalityType' },
    ],
    organizationProfileDetailInfoBoxRowConfigs: [
        {
            valueKey: 'federalStates',
            translationKey: 'customizations:deinstudiumbb.infoBox.federalState',
            iconComponent: BookIcon,
        },
        {
            valueKey: 'universityTypes',
            translationKey: 'customizations:deinstudiumbb.infoBox.universityType',
            iconComponent: BookIcon,
        },
        {
            valueKey: 'studyFormats',
            translationKey: 'customizations:deinstudiumbb.infoBox.studyFormat',
            iconComponent: BookIcon,
        },
        { valueKey: 'topics', translationKey: 'customizations:deinstudiumbb.infoBox.topics', iconComponent: BookIcon },
        {
            valueKey: 'fieldsOfStudy',
            translationKey: 'customizations:deinstudiumbb.infoBox.fieldsOfStudy',
            iconComponent: BookIcon,
        },
        {
            valueKey: 'personalityTypes',
            translationKey: 'customizations:deinstudiumbb.infoBox.personalityType',
            iconComponent: BookIcon,
        },
    ],

    // Flags
    isMessagingEnabled: false,
    isUserProfilesEnabled: false,
    isJobsEnabled: false,
} satisfies Customizations;
